import type { FC, PropsWithChildren } from "react";
import { createContext, useContextSelector } from "use-context-selector";
import { useRightsQuery } from "web_myplann/Api/Rights/useRightsQuery";
import type { RightsResponseDTO } from "web_myplann/Infrastructure/Api/Api";

const RightsContext = createContext<RightsResponseDTO | undefined>(undefined);

export const RightsProvider: FC<PropsWithChildren> = ({ children }) => {
	const { data } = useRightsQuery();

	return (
		<RightsContext.Provider value={data}>{children}</RightsContext.Provider>
	);
};

export const useRights = <T,>(selector: (rights: RightsResponseDTO) => T): T =>
	useContextSelector(RightsContext, (rights) => {
		if (!rights) {
			throw new Error("useRights must be used within RightsProvider");
		}
		return selector(rights);
	});

export const useGoalsRight = () => useRights((rights) => rights.pilotGoal);

export const useGoalsRightOptional = () =>
	useContextSelector(RightsContext, (rights) => rights?.pilotGoal ?? false);

export const usePortfolioRightOptional = () =>
	useContextSelector(
		RightsContext,
		(rights) => rights?.pilotMyplannPortfolio ?? false,
	);
